import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { InputComponent, InputType } from '../controls/input.component';
import { BaseFieldComponent } from './base-field.component';
import { FieldContainerComponent } from './field-container.component';

@Component({
  selector: 'app-input-field',
  imports: [CommonModule, InputComponent, FieldContainerComponent],
  template: `
    <app-field-container
      [label]="label"
      [labelClasses]="labelClasses"
      [valueClasses]="valueClasses"
      [control]="control"
    >
      <ng-template #value>
        <app-input
          [control]="control"
          [screenReaderLabel]="controlLabel || label"
          [placeholder]="placeholder"
          [helpText]="helpText"
          [type]="type"
          [maxlength]="maxlength"
          [trimPaste]="trimPaste"
        />
      </ng-template>
    </app-field-container>
  `,
  styles: ``,
})
export class InputFieldComponent extends BaseFieldComponent {
  @Input()
  type: InputType = 'Text';

  @Input()
  maxlength: number;

  @Input()
  trimPaste = true;
}
